export const UPDATE_USERS = "UPDATE_USERS";

export const updateUsers = (value) => ({
  type: UPDATE_USERS,
  value,
});
